import {FC} from 'react'
import { TicketDashboardPage } from './pages/TicketDashboardPage'

export const TicketLayout: FC = () => <TicketDashboardPage />